import _ from 'lodash';

export function normalizeAsArray<T>(value: T | T[] | undefined | null): T[] {
  if (_.isNil(value)) return [];
  if (Array.isArray(value)) return value;
  return [value];
}
